if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject
) {
	var linkTag = document.createElement("link");
	
	linkTag.rel = "stylesheet";
	linkTag.type="text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}

	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;
	if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
  linkTag.crossOrigin = "anonymous";
}
	(function insert(linkTag) {
      var _document$getElementB;
      if (document.getElementsByTagName('html') && document.getElementsByTagName('html').length === 1 && document.getElementsByTagName('html')[0].getAttribute('dir') === 'rtl') {
        linkTag.setAttribute('href', linkTag.getAttribute('href').replace('.css', '.rtl.css'));
      }
      var insertionPoint = (_document$getElementB = document.getElementById('meta-shell-styles')) !== null && _document$getElementB !== void 0 ? _document$getElementB : document.head;
      return insertionPoint.appendChild(linkTag);
    })(linkTag);
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"runtime": 0,

};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {
"apps_campaign-lab-app_src_CampaignLabLandingPage_tsx-node_modules_pnpm_snapchat_campaign-lab_-95c437": 1,
"vendors-node_modules_pnpm_snapchat_snap-design-system-primitives_1_60_0_node_modules_snapchat-e3941e": 1,
"apps_campaign-lab-app_src_CampaignLabResultPage_tsx-node_modules_pnpm_snapchat_campaign-lab_2-d3118b": 1,
"vendors-node_modules_pnpm_braintree_sanitize-url_5_0_0_node_modules_braintree_sanitize-url_di-849756": 1,
"apps_campaign-lab-app_src_CampaignLabAllResultsPage_tsx-node_modules_pnpm_snapchat_campaign-l-be87e5": 1,
"node_modules_pnpm_snapchat_audience-insights_3_0_1__emotion_css_11_13_0__formatjs_intl_3_1_5_-fe0be3": 1,
"vendors-node_modules_pnpm_mapbox-gl_2_10_0_node_modules_mapbox-gl_dist_mapbox-gl_css-node_mod-bc83a4": 1,
"vendors-node_modules_pnpm_snapchat_snap-design-system-next_1_21_1__snapchat_snap-design-syste-c05fdd": 1,
"node_modules_pnpm_snapchat_ads-global-nav_5_1_0__emotion_css_11_13_0__snapchat_snap-design-sy-72a34f": 1,
"vendors-node_modules_pnpm_snapchat_snap-design-system-primitives_1_60_0_node_modules_snapchat-e412e3": 1,
"vendors-node_modules_pnpm_snapchat_snap-design-system_12_16_1__emotion_css_11_13_0__snapchat_-c0aeef": 1,
"vendors-node_modules_pnpm_snapchat_filter-workshop_15_4_8__emotion_css_11_13_0__snapchat_redu-81f0eb": 1,
"vendors-node_modules_pnpm_snapchat_diagnostics-kit_2_0_1__emotion_css_11_13_0__snapchat_snap--2ec00b": 1,
"src_apps_adsMgr_scripts_ads_selectors_getDpaEndCardEligibilityForAd_ts-src_apps_adsMgr_script-27d52c": 1,
"vendors-node_modules_pnpm_formatjs_intl-pluralrules_4_0_18_node_modules_formatjs_intl-pluralr-2d1c3b": 1,

};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId).then(
				function() {
					installedCssChunks[chunkId] = 0;
				},
				function(e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

// no hmr
